import Vue from 'vue';
import Vuex from 'vuex';
import messages from './modules/messages';
import charities from './modules/charities/moduleCharities';
import campaigns from './modules/campaigns';
import tasks from './modules/tasks';
import lists from './modules/lists/moduleLists';
import createPersistedState from 'vuex-persistedstate';
import auth from './modules/auth/moduleAuth'
import app from './modules/app/moduleApp'
import donations from './modules/donations/moduleDonations'
import roundUps from './modules/round-ups/moduleRoundUps'
import monthlyDonations from './modules/monthly-donations/moduleMonthlyDonations'
import donors from './modules/donors/moduleDonors'
import events from './modules/events/moduleEvents'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const storage = window.localStorage;

export default new Vuex.Store({
    modules: {
        messages,
        charities,
        campaigns,
        tasks,
        auth,
        donations,
        donors,
        roundUps,
        monthlyDonations,
        lists,
        app,
        events,
    },
    strict: debug,
    plugins: [createPersistedState({
        key: 'dashboard_db_v5',
        setState: (key, state, storage) => {
            return storage.setItem(key, JSON.stringify(state));
        },
        storage: {
            getItem: (key) => storage.getItem(key),
            setItem: (key, value) => {
                try {
                    storage.setItem(key, value)
                }
                catch (e) {
                    // eslint-disable-next-line
                    console.warn(e.toString());
                }
            },
            removeItem: (key) => storage.removeItem(key),
        }

    })]
})
